import { event } from '@stereoagency/sanity-schema';

const pickEventFields = [
  '_id' as const,
  'slug' as const,
  'datetime' as const,
  'title' as const,
  'lecturer' as const,
  'lecturerInformation' as const,
  'contact' as const,
  'location' as const,
  'duration' as const,
  'content' as const,
  'organizer' as const
];

const orderedBuilder = event.schema.builder.orderBy(
  'datetime',
  'desc'
) as typeof event.schema.builder;

export const upcomingEventsQuery = orderedBuilder
  .filter('_id != ^._id')
  .pick(pickEventFields)
  .map((resolver) => ({
    taxonomies: resolver.taxonomies
      .resolveIn(['_id', 'type', 'slug', 'name'])
      .use(),
    contact: resolver.contact.resolve(['name', 'firstName', 'email']).use()
  }))
  .select(0, 3, true)
  .use();

export const eventQuery = event.schema.builder
  .filter('slug.current == $slug')
  .pick(pickEventFields)
  .map((resolver) => ({
    taxonomies: resolver.taxonomies
      .resolveIn(['_id', 'type', 'slug', 'name'])
      .use(),
    contact: resolver.contact.resolve(['name', 'firstName', 'email']).use()
  }))
  .subquery({
    upcomingEvents: upcomingEventsQuery
  })
  .first()
  .use();

export const eventByIdQuery = event.schema.builder
  .filter('_id == $id')
  .pick(pickEventFields)
  .map((resolver) => ({
    taxonomies: resolver.taxonomies
      .resolveIn(['_id', 'type', 'slug', 'name'])
      .use(),
    contact: resolver.contact.resolve(['name', 'firstName', 'email']).use()
  }))
  .first()
  .use();
